export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.17-1632.04",
  commitId: "64a5c64f7f5ec0e5370c2fa81efac76df3f18506",
  commitTime: "2026-08-17T16:32:04.000Z",
});
